import { Component, PropsWithChildren } from 'react'
import { STORAGE } from 'project-config/constants'
import { useGlobalStore } from '@/store/global/global-store'
import { ErrorPage } from '@renderbus/widgets/components/error-page'
import { getUserId } from '@/utils'

type PropsType = PropsWithChildren

interface ErrorBoundaryState {
  error: object | null
}
export function ErrorPageWrapper() {
  const { userInfo } = useGlobalStore()
  const fallbackUserInfo = userInfo?.userId || Number(getUserId())
  return <ErrorPage userId={fallbackUserInfo} />
}
class ErrorBoundary extends Component<PropsType, ErrorBoundaryState> {
  constructor(props: PropsType) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: object) {
    return { error }
  }

  componentDidCatch(error: object) {
    this.setState({ error })
  }

  render() {
    const { error } = this.state
    const { children } = this.props

    if (error) {
      sessionStorage.setItem(STORAGE.NETWORK_ERROR, JSON.stringify(error))
      return <ErrorPageWrapper />
    }

    return children
  }
}

export default ErrorBoundary
